import { FC } from "react";
import { useSearchParams } from "react-router-dom";
import { SplitLayout } from "~/components/layouts/SplitLayout";
import { ShareAccessDenied } from "~/features/share/components/ShareAccessDenied";

export const ShareAccessDeniedPage: FC = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get("message") || undefined;

  return (
    <SplitLayout>
      <ShareAccessDenied message={message} />
    </SplitLayout>
  );
};
